import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../../commonDesign/SydModal'
import SydModalActions from '../../../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../../commonDesign/Button'
import { useArchiveClientStatusReport } from '../../../../../../../api/groups'
import Alert from '../../../../../../atoms/Alert'
import { ALERT_SEVERITY, ALERT_VARIANT } from '../../../../../../../constants'

function FinalizeReportModal ({
  open,
  onClose,
  statusReportId
}) {
  const { mutate, isLoading, isError } = useArchiveClientStatusReport()

  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Archive this Status Report'
      subtitle='Are you sure you want to archive this status report.  It will no longer be editable.'
    >
      <div className='flex flex-col'>
        {isError && (
          <Alert variant={ALERT_VARIANT.standard} severity={ALERT_SEVERITY.error}>
            An error occurred archiving the status report
          </Alert>
        )}

        <SydModalActions>
          <SydButton
            variant='secondary'
            size='md'
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </SydButton>

          <SydButton
            priority='warning'
            variant='primary'
            size='md'
            type='submit'
            disabled={isLoading}
            processing={isLoading}
            onClick={async () => {
              await mutate({ statusReportId })
              onClose?.()
            }}
          >
            {isLoading ? 'Saving...' : 'Archive'}
          </SydButton>
        </SydModalActions>
      </div>
    </SydModal>
  )
}

FinalizeReportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  statusReportId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
}

export default FinalizeReportModal
